var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolarpanelsSun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_1826",
    "data-name": "Groupe 1826",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 55.302,
    height: 55.306,
    viewBox: "0 0 55.302 55.306",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_444",
    "data-name": "Trac\\xE9 444",
    d: "M82.138-71.8v2.765H80.295V-71.8Zm6.247-3.353L90.34-73.2l-1.3,1.3-1.955-1.955Zm-14.339,0,1.3,1.3-1.955,1.955-1.3-1.3Zm7.17-13.238a7.374,7.374,0,0,1,7.374,7.374,7.374,7.374,0,0,1-7.374,7.374,7.383,7.383,0,0,1-7.374-7.374A7.374,7.374,0,0,1,81.217-88.391Zm0,1.844a5.536,5.536,0,0,0-5.531,5.531,5.531,5.531,0,0,0,5.531,5.531,5.531,5.531,0,0,0,5.531-5.531A5.531,5.531,0,0,0,81.217-86.548ZM72-81.939V-80.1H69.233v-1.844Zm21.2,0V-80.1H90.434v-1.844Zm-19.805-8.2,1.955,1.955-1.3,1.3-1.955-1.955Zm15.644,0,1.3,1.3-1.955,1.955-1.3-1.3ZM82.138-93v2.765H80.295V-93Z",
    transform: "translate(-69.233 93)",
    fill: "#e6f6fb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_443",
    "data-name": "Trac\\xE9 443",
    d: "M-937,740.366H106.792V-2067H-937Z",
    transform: "translate(937 2067)",
    fill: "#e6f6fb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_447",
    "data-name": "Trac\\xE9 447",
    d: "M75.662-34.158,53.539-74.716a.922.922,0,0,0-.809-.48H26.92a.959.959,0,0,0-.206.027h-.022a.892.892,0,0,0-.253.112.7.7,0,0,0-.066.05.964.964,0,0,0-.2.2c-.013.019-.03.035-.042.055a.8.8,0,0,0-.05.116.748.748,0,0,0-.032.074.921.921,0,0,0-.046.277v6.46a.924.924,0,0,0,.111.439L44.545-33.278a.922.922,0,0,0,.811.483h29.5a.922.922,0,0,0,.922-.922A.922.922,0,0,0,75.662-34.158Zm-7.893-10.62h-6.2l-4.525-8.3h6.2ZM45.646-54.918H38.529L34-63.214h7.117Zm-2.424-8.3h6.2l4.525,8.3h-6.2Zm3.43,10.14,4.525,8.3H44.06l-4.525-8.3Zm2.1,0h6.2l4.525,8.3h-6.2Zm13.486-1.844h-6.2l-4.525-8.3h6.2ZM52.182-73.353l4.525,8.3h-6.2l-4.525-8.3Zm-8.3,0,4.525,8.3h-6.2l-4.525-8.3Zm-8.3,0,4.525,8.3H33l-4.525-8.3ZM45.909-34.639,27.842-68.056v-2.6L47.49-34.639Zm3.682,0-4.525-8.3h7.117l4.525,8.3Zm9.218,0-4.525-8.3h6.2L65-34.639Zm8.3,0-4.525-8.3h6.2l4.525,8.3Z",
    transform: "translate(-26.003 75.197)",
    fill: "#00a3da"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_446",
    "data-name": "Trac\\xE9 446",
    d: "M-937,740.366H106.792V-2067H-937Z",
    transform: "translate(937 2067)",
    fill: "#00a3da"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1764",
    "data-name": "Groupe 1764",
    transform: "translate(31.336 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1763",
    "data-name": "Groupe 1763",
    transform: "translate(-729.374 -1430.865)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_442",
    "data-name": "Trac\\xE9 442",
    d: "M68.233-94H93.649v25.416H68.233Z",
    transform: "translate(660.416 1524.14)",
    fill: "#e6f6fb"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1766",
    "data-name": "Groupe 1766",
    transform: "translate(0 12.905)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1765",
    "data-name": "Groupe 1765",
    transform: "translate(-698.038 -1443.77)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_445",
    "data-name": "Trac\\xE9 445",
    d: "M25-76.2H76.224v43.851H25Z",
    transform: "translate(672.31 1519.242)",
    fill: "#00a3da"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarpanelsSun);
export default __webpack_public_path__ + "static/media/solarpanels-sun.488a240600701096d5dbf7c537ad52a7.svg";
export { ForwardRef as ReactComponent };